import * as React from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
// import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
// import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import instance, { setAuthToken } from "../services/api";
import LinearProgress from "@mui/material/LinearProgress";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
// import Draggable from "react-draggable";

export default function AddCustomer(props) {
  const [loading, setLoading] = React.useState(false);
  const { onClose, selectedValue, open } = props;
  const [formData, setFormData] = React.useState({
    email: null,
    password: null,
    name: null,
    phone: null,
    user_type: "OUTS3",
  });

  const handleClose = () => {
    onClose(selectedValue);
  };

  const onAdd = () => {
    setLoading(true);
    setAuthToken(localStorage.getItem("token"));
    instance
      .post("/admin/create_user/", formData)
      .then((response) => {
        console.log("response.data.success: ", response.data.success);
        if (response.data.status === "success") {
          setLoading(false);
          setSnackbar(true);
          setSnackBarMsg("Customer added successfully.");
          setSnackBarSeverity("success");
          handleClose();
          props.refetch();
        }
      })
      .catch((error) => {
        setSnackBarMsg(error.response.data.error);
        setSnackBarSeverity("error");
        setSnackbar(true);
        setLoading(false);
      });
  };

  const [openSnackbar, setSnackbar] = React.useState(false);
  const [snackBarSeverity, setSnackBarSeverity] = React.useState("success");
  const [snackBarMsg, setSnackBarMsg] = React.useState(false);
  const handleSnackbarClose = () => {
    setSnackbar(false);
    setSnackBarSeverity("success");
    setSnackBarMsg("");
  };

  return (
    <>
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>Add Customer</DialogTitle>
        <Box sx={{ width: "100%" }}>{loading && <LinearProgress />}</Box>
        <DialogContent dividers>
          <Box component="form" noValidate sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  autoComplete="given-name"
                  name="firstName"
                  required
                  fullWidth
                  id="firstName"
                  label="Name"
                  autoFocus
                  onChange={(event) => {
                    setFormData({
                      ...formData,
                      name: event.target.value,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="Phone Number"
                  variant="outlined"
                  name="phone"
                  onChange={(event) => {
                    setFormData({
                      ...formData,
                      phone: event.target.value,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  onChange={(event) => {
                    setFormData({
                      ...formData,
                      email: event.target.value,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="new-password"
                  onChange={(event) => {
                    setFormData({
                      ...formData,
                      password: event.target.value,
                    });
                  }}
                />
              </Grid>
            </Grid>
            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={onAdd}
            >
              <span>Add</span>
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={openSnackbar}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleClose} severity={snackBarSeverity}>
          {snackBarMsg}
        </Alert>
      </Snackbar>
    </>
  );
}
